module.exports = __webpack_public_path__ + "static/na-kanalima-6aecd9cb5a67801d8c353b0803c5e2da.svg";